<template>
    <div class="time-select-content" :class="{ 'time-select-content-swi': switchIcon }">
        <img :src="require('@/assets/images/service/customerscoring/analysis-date-select-icon.png')" class="icon" alt="" />
        <div class="time-view" :class="{ 'switch-icon-view': switchIcon }">
            <div @click="changeTimePickerVisible()" class="time-value">{{ sStartTime }}</div>
            <div class="zhi">至</div>
            <div @click="changeTimePickerVisible()" class="time-value">{{ sEndTime }}</div>
        </div>
        <img
            v-if="switchIcon"
            @click="openOrder"
            :src="require('@/assets/images/service/customerscoring/analysis-date-switch-icon.png')"
            class="icon"
            alt=""
        />
        <!-- 顺序切换弹窗 -->
        <div class="order" v-show="isShowOrder">
            <div class="order-item" v-for="item in objOrder" :key="item.id" @click="selectOrderText(item.id)">{{ item.name }}</div>
        </div>
        <!--    时间选择弹窗    -->
<!--        <VantPopup v-model="bTimeVisible" position="bottom" round >-->
<!--            <DatetimePicker :value="timeSelect" @confirm="setTimeValue" @cancel="changeTimePickerVisible" type="date"  :max-date="maxDate"   :min-date="dateStartTime"></DatetimePicker>-->
<!--        </VantPopup>-->

        <!-- 时间筛选项选择器 -->
        <van-popup v-model="bTimeVisible" round position="bottom">
            <div class="time-item-wrap">
                <div class="time-item-title">
                    <div></div>
                    <div>周期</div>
                </div>
                <div class="time-item-content">
                    <div v-for="(item, index) in timeSelectList" :key="index" :class="['time-item-content-item', timeSelectCurrent == index && 'time-item-content-item-act']" @click="changeSelectTime(index)">
                        {{ item }}
                    </div>
                </div>
                <div class="time-input-wrap">
                    <div :class="['time-input-item', timeSelectItem == 'start' && 'time-input-item-act']" @click.stop="onDateShow('start', 'btn')">{{ dateTime[0] }}
                    </div>
                    至
                    <div :class="['time-input-item', timeSelectItem == 'end' && 'time-input-item-act']" @click.stop="onDateShow('end', 'btn')">{{ dateTime[1] }}
                    </div>
                </div>
            </div>

            <div class="search-btn" @click="checkData">
                <div class="btn">查询</div>
            </div>

            <transition name="fade">
                <div class="timepicker-wrap" v-if="show">
                    <van-datetime-picker type="date" :title="dateTitle" v-model="timeSelect" :min-date="dateStartTime" :max-date="maxDate" @cancel="onDateCancel" @confirm="onDateConfirm" />
                </div>
            </transition>
        </van-popup>
    </div>
</template>

<script>
import { DatetimePicker, Popup } from "vant";
import day from "dayjs";
import { Toast } from "mint-ui";
import {getTimeDate} from "@/js/service"
import oWarmJs from "@/js/hvac/dossier/warm";
export default {
    name: "timeselect",
    props: {
        // 是否显示后置切换图标
        switchIcon: Boolean,
        initType:{
            type:String,
            default:''
        },
    },
    components: {
        DatetimePicker,
        VantPopup: Popup,
    },
    data() {
        return {
            timeSelectList: ['总计', '年累计', '月累计', '周累计', '昨天'], // 时间筛选项数组
            maxDate:new Date(),
            // 开始时间
            sStartTime: "开始时间",//已选择时间
            // 结束时间
            sEndTime: "结束时间",//已选择时间
            // 选择器显示
            bTimeVisible: false,
            timeSelect:null,//用了绑定日期选择的值
            // 选择器的绑定值
            // 顺序切换
            isShowOrder: false,
            // 排序方式
            nOrderId: null,
            dateTitle: '请选择开始时间',
            // 顺序切换按钮文字
            objOrder: [
                { id: 2, name: "项目服务评分降序" },
                // { id: 3, name: "用户满意评分降序" },
                // { id: 5, name: "综合服务评分降序" },
                { id: 1, name: "项目服务评分升序" },
                // { id: 4, name: "用户满意评分升序" },
                // { id: 6, name: "综合服务评分升序" },
            ],
            dateStartTime:new Date(2022,0,14),//有数据的最开始时间
            timeSelectCurrent:'1',//时间段选择索引
            timeSelectItem: '1', // 开始还是结束时间选择索引
            dateTime: ['', ''],//暂时选择的时间显示
            show: true,//是否显示时间选择器
            dateKey: 'start',//选择的开始还是结束
            timeItemAllArr: [], // 时间筛选项对应的时间数组
        };
    },
    created(){
        console.log(this.$store.state.timeType,'this.$store.state.timeType')
        this.timeSelectCurrent=this.$store.state.timeType
        this.getTime()
        // this.getDateData()
    },
    watch:{
        sEndTime(a,b){
            this.$emit("screen", { sStartTime: this.sStartTime, sEndTime: this.sEndTime, nOrderId: this.nOrderId });
        }
    },
    computed: {

    },
    methods: {
        // 获取时间项的具体时间
        getTimeItem(time) {
            let date = new Date();
            // 当年
            const toYear = date.getFullYear() + '/01/01';
            // 当月
            const toMonth = date.getFullYear() + '/' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
            // 当天
            const today = (date.getFullYear() + '/' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '/' + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()));
            // 昨天
            let yesterdayDate = new Date(today);
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);
            const yesterday = yesterdayDate.getFullYear() + '/' + ((yesterdayDate.getMonth() + 1) < 10 ? '0' + (yesterdayDate.getMonth() + 1) : (yesterdayDate.getMonth() + 1)) + '/' + (yesterdayDate.getDate() < 10 ? ('0' + yesterdayDate.getDate()) : yesterdayDate.getDate());
            // 本周一
            let mondayDate = new Date(date);
            mondayDate.setDate(date.getDate() - date.getDay() + 1);
            const monday = mondayDate.getFullYear() + '/' + ((mondayDate.getMonth() + 1) < 10 ? '0' + (mondayDate.getMonth() + 1) : (mondayDate.getMonth() + 1)) + '/' + (mondayDate.getDate() < 10 ? ('0' + mondayDate.getDate()) : mondayDate.getDate());

            // 计算账期开始日期
            let currentYear = date.getFullYear()
            let currentMonth = date.getMonth() + 1
            let currentDate = date.getDate()
            let tempTime = currentYear + '/12/27'
            let checkStartTime = ''
            // let checkEndTime = currentYear + '/' + currentMonth + '/' + currentDate
            if (new Date().getTime() < new Date(tempTime).getTime()) {
                checkStartTime = currentYear - 1 + '/12/28'
            } else {
                checkStartTime = currentYear + '/12/28'
            }
            this.timeItemAllArr = [[time, today], [checkStartTime, today], [toMonth + '/01', today], [monday, today], [yesterday, yesterday]]
            // 判断之前是否有切换时间,有的话使用上次切换时间
            let objStorageTime =this.$store.state.objStorageTime
            if(objStorageTime && objStorageTime.startTime){
                this.sStartTime = objStorageTime.startTime
                this.sEndTime =  objStorageTime.endTime
                this.timeSelect = new Date(objStorageTime.startTime);
                this.dateTime = [objStorageTime.startTime, objStorageTime.endTime];
            }else{
                this.sStartTime = time
                this.sEndTime = today
                this.timeSelect = new Date(time);
                this.dateTime = [time, today];
            }
        },
        //获取时间范围
        getDateData() {
            let date = new Date()
            // 当前时间没过今年12/27的话，账期开始时间就用上一年的12/28 账期结束时间就用今天
            // 过了的话就用今年的12/28 账期结束时间用今天
            let currentYear = date.getFullYear()
            let currentMonth = date.getMonth() + 1
            let currentDate = date.getDate()
            let tempTime = currentYear + '/12/27'
            let checkStartTime = ''
            let checkEndTime = currentYear + '/' + currentMonth + '/' + currentDate
            if (new Date().getTime() < new Date(tempTime).getTime()) {
                checkStartTime = currentYear - 1 + '/12/28'
            } else {
                checkStartTime = currentYear + '/12/28'
            }

            // 判断之前是否有切换时间,有的话使用上次切换时间
            let objStorageTime =this.$store.state.objStorageTime
            if(objStorageTime && objStorageTime.startTime){
                this.sStartTime = objStorageTime.startTime
                this.sEndTime =  objStorageTime.endTime
                this.timeSelect = new Date(objStorageTime.startTime);
                this.dateTime = [objStorageTime.startTime, objStorageTime.endTime];
            }else{
                this.sStartTime = checkStartTime
                this.sEndTime = checkEndTime
                this.timeSelect = new Date(this.sStartTime);
                this.dateTime = [this.sStartTime, this.sEndTime];
            }
        },
        // 点击查询
        checkData() {
            this.bTimeVisible = false
            this.sStartTime=this.dateTime[0]
            this.sEndTime=this.dateTime[1]
            this.$emit("screen", { sStartTime: this.sStartTime, sEndTime: this.sEndTime, nOrderId: this.nOrderId });
            this.$store.commit('editObjTime',{startTime:this.sStartTime,endTime:this.sEndTime})
        },
        onDateShow(key, type) {
            this.dateKey = key;
            this.timeSelectItem = key
            this.show = false
            setTimeout(() => {
                if (key == 'start') {
                    this.dateTitle = '请选择开始时间';
                    this.timeSelect = new Date(this.dateTime[0]);
                    if (this.dateTime[1] != '') {
                        this.maxDate = new Date(this.dateTime[1]);
                    }
                } else {
                    this.dateTitle = '请选择结束时间';
                    this.timeSelect = new Date(this.dateTime[1])
                    this.maxDate = new Date(this.sEndTime);
                }

                if (type == 'btn') {
                    this.maxDate = new Date();
                }
                this.show = true;
            }, 100)
            this.show = false;
        },
        // 点击时间项改变时间
        changeSelectTime(index) {
            if (index == this.timeSelectCurrent) return
            this.timeSelectCurrent = index
            this.$store.commit('editTimeType',index)
            this.timeSelectItem = ''

            switch (index) {
                case 0: // 总计 2021-01-01到当天
                    this.dateTime = this.timeItemAllArr[0];
                    break;
                case 1: // 当年 当年1.1至当天
                    this.dateTime = this.timeItemAllArr[1];
                    break;
                case 2: // 月累计 当月1号至当天
                    this.dateTime = this.timeItemAllArr[2];
                    break;
                case 3: // 周累计 当周周一至当天
                    this.dateTime = this.timeItemAllArr[3];
                    break;
                case 4: // 昨日
                    this.dateTime = this.timeItemAllArr[4];
                    break;
            }

            // 点击时间项后下方的日期选择变为周期的开始时间
            this.onDateShow('start')
        },
        // 获取有数据的时间
        getTime(){
            getTimeDate({code:'index'}).then(res=>{
                if(res.data.data.result.start_time){
                    this.dateStartTime=new Date(res.data.data.result.start_time)
                    this.getTimeItem(res.data.data.result.start_time.replaceAll('-','/'))
                }
            })
        },
        //   回复数据
        newTem() {
            Object.assign(this.$data, this.$options.data()); // 初始化data
        },
        selectOrderText(id) {
            // 选择排序方式
            this.nOrderId = id;
            this.$emit("screen", { sStartTime: this.sStartTime, sEndTime: this.sEndTime, nOrderId: this.nOrderId });
            this.isShowOrder = false;
        },
        // 打开顺序弹框
        openOrder() {
            this.isShowOrder = !this.isShowOrder;
        },
        /**
         * 改变弹窗显示和设置时间绑定值
         * @param key
         */
        changeTimePickerVisible() {
            this.onDateShow('start')
            this.bTimeVisible = !this.bTimeVisible;
            this.isShowOrder = false;
        },
        onDateCancel() {
            this.dateTitle = '请点击查询按钮筛选'
        },
        // 判断两个时间的前后
        compareDate(currentTime, activeTime) {
            let currentTimes = currentTime.replace(/-/g, '/');
            let activeTimes = activeTime.replace(/-/g, '/');
            let a = (Date.parse(activeTimes) - Date.parse(currentTimes)) / 3600 / 1000;
            if (a < 0) {
                return false;
            } else if (a > 0) {
                return true;
            }
        },
        onDateConfirm(e) {
            if (this.dateKey == 'start') {
                let obj = {
                    start:e,end:new Date(this.dateTime[1])
                }
                this.onConfirm(obj, 'start')
                this.onDateCancel();
            } else {
                let obj = {
                    start:new Date(this.dateTime[0]),end:e
                }
                this.onConfirm(obj, 'end')
                this.onDateCancel();
            }
        },
        onConfirm(date, type) {
            const { start, end } = date;
            this.dateTime = [this.formatDate(start), this.formatDate(end)];
            // 判断手动修改的时间是否满足筛选项高亮
            this.timeSelect = this.judgeTimeItem(this.dateTime)
            if (type == 'start') {
                // 切到结束时间去
                this.onDateShow('end')
                return
            }
        },
        formatDate(date) {
            let month = date.getMonth() + 1;
            let day = date.getDate();
            return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
        },
        // 判断所选时间是否满足所选项
        judgeTimeItem(arr) {
            let index = -1
            let flag = true;
            for (let i = 0; i < this.timeItemAllArr.length; i++) {
                index = i;
                for (let j = 0; j < this.timeItemAllArr[i].length; j++) {
                    if (this.timeItemAllArr[i][j] != arr[j]) {
                        flag = false
                        break;
                    }
                }
                if (flag) {
                    break;
                } else {
                    if (index == this.timeItemAllArr.length - 1) {
                        index = -1
                    }
                    flag = true
                }
            }
            return index
        },
        /**
         * 设置当前时间
         * @param v
         */
        setTimeValue(v) {
            this[this.sTimeSelect] = new day(v).format("YYYY-MM-DD");
            if(this.sStartTime!="开始时间" && this.sEndTime!="结束时间"){
                if( this.compareDate(this.sEndTime,this.sStartTime)){
                    console.log(1)
                    Toast({
                        message: "开始时间不能晚于结束时间",
                        duration: 2000
                    });
                }
            }
            this.$emit("screen", { sStartTime: this.sStartTime, sEndTime: this.sEndTime, nOrderId: this.nOrderId });
            this.bTimeVisible = !this.bTimeVisible;
        },
    },
};
</script>

<style scoped lang="scss">
// 时间选择项样式
.time-item-wrap {
    padding: 6%;
    box-sizing: border-box;

    .time-item-title {
        display: flex;
        align-items: center;
        margin-bottom: 32px;

        div:first-child {
            width: 4px;
            height: 26px;
            background: #0d53fc;
        }

        div:last-child {
            font-size: 28px;
            font-weight: 400;
            margin-left: 12px;
            font-family: Abel-Regular, Abel;
            color: #333333;
            line-height: 33px;
        }
    }

    .time-item-content {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time-item-content-item {
            padding: 18px;
            border: 1px solid #ddd;
            border-radius: 16px;

            font-size: 24px;
            color: #666666;
            line-height: 28px;
        }

        .time-item-content-item-act {
            padding: 20px;
            color: #0d53fc;
            border: none;
            background: rgba(13, 83, 252, 0.1);
        }
    }

    .time-input-wrap {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #666666;
        font-size: 24px;

        .time-input-item {
            width: 40%;
            padding: 18px;
            border: 1px solid #ddd;
            border-radius: 16px;
            font-size: 24px;
            color: #666666;
            line-height: 28px;
            text-align: center;
        }

        .time-input-item-act {
            padding: 20px;
            color: #0d53fc;
            border: none;
            background: rgba(13, 83, 252, 0.1);
        }
    }
}
// 搜索按钮样式
.search-btn {
    width: 100%;
    height: 180px;
    background: #ffffff;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99999;
    box-shadow: 0px -10px 16px rgba(230, 240, 255, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
        width: 434px;
        height: 72px;
        background: #0d53fc;
        border-radius: 16px 16px 16px 16px;

        font-size: 24px;
        font-family: Abel-Regular, Abel;
        font-weight: 400;
        color: #ffffff;
        line-height: 72px;
        text-align: center;
    }
}
.time-select-content {
    height: 80px;
    background: #f7f7f7;
    border-radius: $commonRadius;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    position: relative;
    .order {
        // width: 240px;
        // height: 488px;
        white-space: nowrap;
        background: #ffffff;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
        border-radius: 7px;
        position: absolute;
        right: 22px;
        top: 80px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        padding: 0 20px;
        .order-item {
            white-space: nowrap;
            height: 81px;
            line-height: 81px;
            border-bottom: 1px solid #f5f5f5;
        }
    }

    .icon {
        width: 40px;
        height: 40px;
    }

    .time-view {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 94px 0 56px;
        color: #a2a2a2;
        font-size: $smallSize;
        .time-value{
            width:40%;
            text-align: center;
        }

        .zhi {
            font-size: $baseSize;
            color: #858585;
        }
    }

    .switch-icon-view {
        padding: 0 80px;
    }
}

.time-select-content-swi {
    padding: 0 16px;
}
</style>
